<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <ul>
                <li><a routerLink="/">Home</a></li>
                <li>Contatti</li>
            </ul>
            <h2>Contattaci</h2>
        </div>
    </div>
    <div class="shape9"><img src="assets/img/shape8.svg" alt="image"></div>
</div>

<div id="map">
    <iframe src="https://maps.google.com/maps?q=Via%20Variante%207%20bis%20Mariglianella,%20Italia&t=k&z=19&ie=UTF8&iwloc=&output=embed"></iframe>
</div>

<div class="contact-area ptb-100">
    <div class="container">
        <div class="row mb-5">
            <div class="col-lg-6 col-md-12">
                <div class="contact-info">
                    <span class="sub-title">Chi siamo</span>
                    <h2>Il Migliore Ente di Formazione Accreditato e Certificato</h2>
                    <p>
                        J-Road è una cooperativa sociale che nasce con l’obiettivo di seguire e supportare i candidati nella ricerca della propria strada professionale e formativa. Il ruolo chiave della nostra Academy  è quello di formare e aiutare, adolescenti e non, a realizzare i propri sogni nel mondo del lavoro. Inoltre, ci avvaliamo della Junior Academy, dedicata ai più giovani, con l’intento di favorire la crescita e indirizzare i ragazzi verso il futuro che hanno sempre desiderato.
                    </p>
                    <p>
                        J-Road conta di numerose collaborazioni, come quella tra scuole e aziende, per creare una stretta e migliore compatibilità tra domanda e offerta, su tutto il territorio campano. Il punto di riferimento di tutte le nostre iniziative saranno i Global Goals (SDGs) proposti dall’ONU nella agenda del 2030, tali obiettivi permetteranno alla nostra azienda una crescita costante ed esponenziale nel corso degli anni.
                    </p>
                </div>
            </div>
            <div class="col-lg-6 col-md-12">
                <div class="contact-info">
                    <span class="sub-title">dalla formazione alla professione</span>
                    <h2>Cosa abbiamo di Speciale?</h2>
                    <p><b>Partecipazione: </b>Creiamo un ambiente positivo e dinamico, in cui tutti si sentono liberi, incoraggiando la partecipazione ed il coinvolgimento di ogni essere umano.</p>
                    <p>
                        <b>Professionalità: </b>Studenti, aziende, scuole e partner sono la linfa della nostra cooperativa. Per questo, cerchiamo di soddisfare o superare le loro aspettative su ogni esperienza, garantendo la nostra professionalità.
                    </p>
                    <p>
                        <b>Miglioramento continuo:</b> Il nostro successo è frutto dell’energia collettiva e dei contributi di tutti i membri del nostro team che ci aiutano a migliorare in tutte le attività.
                    </p>
                    <p>
                        <b>Integrità:</b> Restiamo sempre coerenti e corretti con il nostro operato ed i nostri valori, in modo chiaro e trasparente che ci contraddistingue.
                    </p>
                    <p>
                        <b>Collaborazione: </b> Favoriamo un clima di collaborazione e di cooperazione interno ed esterno all’azienda, grazie all’ascolto ed alle partnership.
                    </p>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-6 col-md-12">
                <div class="contact-info">
                    <span class="sub-title">Informazioni</span>
                    <h2>Mettiti in contatto</h2>
                    <p>Ci piace ascoltare i lettori. Apprezziamo davvero che tu abbia dedicato del tempo per metterci in contatto.</p>
                    <ul>
                        <li>
                            <div class="icon">
                                <i class='bx bx-map'></i>
                            </div>
                            <h3>Dove siamo</h3>
                            <p>Via Variante 7 Bis<br>80030 Mariglianella (NA)</p>
                        </li>
                        <li>
                            <div class="icon">
                                <i class='bx bx-phone-call'></i>
                            </div>
                            <h3>Contatti</h3>
                            <p>Mobile: <a href="tel:+390813352659">(+39) 081-3352659</a></p>
                            <p>e-mail: <a href="mailto:info@jroadacademy.com">info@jroadacademy.com</a></p>
                        </li>
                        <li>
                            <div class="icon">
                                <i class='bx bx-time-five'></i>
                            </div>
                            <h3>Siamo disponibili</h3>
                            <p>Lunedì - Venerdì: 09:00 - 18:00</p>
                            <p>Sabato: 09:00 - 13:00</p>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="col-lg-6 col-md-12">
                <div class="contact-form" *ngFor="let Image of bgImage;" style="background-image: url({{Image.img}});">
                    <h2 class="text-dark">Come possiamo aiutarti?</h2>
                    <p class="text-dark">L'indirizzo email non verrà pubblicato. i campi richiesti sono contrassegnati dal simbolo*</p>
                    <form #contactForm="ngForm" (ngSubmit)="submit(contactForm.value)">
                        <div class="row">
                            <div class="col-lg-12 col-md-6">
                                <div class="form-group">
                                    <input required minlength="3" maxlength="50" ngModel name="name" type="text" #name="ngModel" class="form-control" id="name" placeholder="Nome e Cognome">
                                    <div class="alert alert-danger" *ngIf="name.touched && !name.valid">
                                        <div *ngIf="name.errors.required">Nome e Cognome richiesto.</div>
                                        <div *ngIf="name.errors.minlength">Numero minimo {{ name.errors.minlength.requiredLength }} di caratteri.</div>
                                        <div *ngIf="name.errors.maxlength">Numero massimo di 50 caratteri.</div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-12 col-md-6">
                                <div class="form-group">
                                    <input required ngModel name="email" type="text" #email="ngModel" class="form-control" id="email" placeholder="la tua e-mail">
                                </div>
                            </div>
                            <div class="col-lg-12 col-md-12">
                                <div class="form-group">
                                    <input required ngModel name="number" type="text" #number="ngModel" class="form-control" id="number" placeholder="cellulare">
                                    <div class="alert alert-danger" *ngIf="number.touched && !number.valid">un contatto telefonico è obbligatorio</div>
                                </div>
                            </div>
                            <div class="col-lg-12 col-md-12">
                                <div class="form-group">
                                    <textarea required ngModel #message="ngModel" name="message" id="message" cols="30" rows="5" class="form-control" placeholder="scrivi il tuo messaggio..."></textarea>
                                    <div class="alert alert-danger" *ngIf="message.touched && !name.valid">il messaggio è obbligatorio</div>
                                </div>
                            </div>
                            <h2 class="mt-3 text-dark">Quale corso sei interessato?</h2>
                            <p class="text-dark">seleziona il corso interessato alla quale vuoi avere informazioni*</p>

                            <div class="col-lg-12 col-md-12">
                                <div class="form-group">
                                    <select name="sceltaCorso" ngModel id="sceltaCorso" #sceltaCorso="ngModel" style="display: block;
                                    width: 100%;
                                    border: none;
                                    color: var(--blackColor);
                                    background-color: #F3F6F9;
                                    height: 50px;
                                    padding-left: 15px;
                                    border-radius: 5px;
                                    font-size: var(--fontSize);
                                    font-weight: 600">
                                        <option value="{{elencoCorsiRow['corso']['titolo']}}" *ngFor="let elencoCorsiRow of elencoCorsi">{{elencoCorsiRow['corso']['titolo']}}</option>
                                      </select>
                                </div>
                            </div>
                            <div class="col-lg-12 col-md-12 mt-3">
                                <button type="submit" class="default-btn text-white" [class.disabled]="!contactForm.valid">Invia Richiesta<span></span></button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>
